module.exports = __webpack_public_path__ + "img/ZetaChain.6fe1103e.png";